/** See AA p144 */
const sunMeanAnomaly = [357.52772, 35999.050340, -0.0001603, -1 / 300000];

/** See AA p163 Eq 25.2 */
const sunMeanLongitude = [280.46646, 36000.76983, 0.0003032];

/** See AA p147 Eq22.3 */
const meanObliquityOfEcliptic =
    [84381.448 / 3600, -4680.93 / 3600, -1.55 / 3600, 1999.25 / 3600, -51.38 / 3600, -249.67 / 3600, -39.05 / 3600,
        7.12 / 3600, 27.87 / 3600, 5.79 / 3600, 2.45 / 3600];

/** See AA p144 */
const moonArgumentOfLatitude =
    [93.27191, 483202.017538, -0.0036825, 1 / 327270];

/** See AA p144 */
const moonAscendingNodeLongitude = [125.04452, -1934.136261, 0.0020708, 1 / 450000];

/** See AA p144 */
const moonMeanAnomaly = [134.96298, 477198.867398, 0.0086972, 1 / 56250];

/** See AA p144 */
const moonMeanElongation = [297.85036, 445267.111480, -0.0019142, 1 / 189474];

/* eslint-disable no-multi-spaces, array-bracket-spacing */
/**
 * Nutations in longitude and obliquity
 * See AA p145f
 */
const nutations =
    [
        [ 0,  0,  0,  0, 1, -171996, -174.2, 92025,  8.9],
        [-2,  0,  0,  2, 2,  -13187,   -1.6,  5736, -3.1],
        [ 0,  0,  0,  2, 2,   -2274,   -0.2,   977, -0.5],
        [ 0,  0,  0,  0, 2,    2062,    0.2,  -895,  0.5],
        [ 0,  1,  0,  0, 0,    1426,   -3.4,    54, -0.1],
        [ 0,  0,  1,  0, 0,     712,    0.1,    -7,    0],
        [-2,  1,  0,  2, 2,    -517,    1.2,   224, -0.6],
        [ 0,  0,  0,  2, 1,    -386,   -0.4,   200,    0],
        [ 0,  0,  1,  2, 2,    -301,      0,   129, -0.1],
        [-2, -1,  0,  2, 2,     217,   -0.5,   -95,  0.3],
        [-2,  0,  1,  0, 0,    -158,      0,     0,    0],
        [-2,  0,  0,  2, 1,     129,    0.1,   -70,    0],
        [ 0,  0, -1,  2, 2,     123,      0,   -53,    0],
        [ 2,  0,  0,  0, 0,      63,      0,     0,    0],
        [ 0,  0,  1,  0, 1,      63,    0.1,   -33,    0],
        [ 2,  0, -1,  2, 2,     -59,      0,    26,    0],
        [ 0,  0, -1,  0, 1,     -58,   -0.1,    32,    0],
        [ 0,  0,  1,  2, 1,     -51,      0,    27,    0],
        [-2,  0,  2,  0, 0,      48,      0,     0,    0],
        [ 0,  0, -2,  2, 1,      46,      0,   -24,    0],
        [ 2,  0,  0,  2, 2,     -38,      0,    16,    0],
        [ 0,  0,  2,  2, 2,     -31,      0,    13,    0],
        [ 0,  0,  2,  0, 0,      29,      0,     0,    0],
        [-2,  0,  1,  2, 2,      29,      0,   -12,    0],
        [ 0,  0,  0,  2, 0,      26,      0,     0,    0],
        [-2,  0,  0,  2, 0,     -22,      0,     0,    0],
        [ 0,  0, -1,  2, 1,      21,      0,   -10,    0],
        [ 0,  2,  0,  0, 0,      17,   -0.1,     0,    0],
        [ 2,  0, -1,  0, 1,      16,      0,    -8,    0],
        [-2,  2,  0,  2, 2,     -16,    0.1,     7,    0],
        [ 0,  1,  0,  0, 1,     -15,      0,     9,    0],
        [-2,  0,  1,  0, 1,     -13,      0,     7,    0],
        [ 0, -1,  0,  0, 1,     -12,      0,     6,    0],
        [ 0,  0,  2, -2, 0,      11,      0,     0,    0],
        [ 2,  0, -1,  2, 1,     -10,      0,     5,    0],
        [ 2,  0,  1,  2, 2,     -8,       0,     3,    0],
        [ 0,  1,  0,  2, 2,      7,       0,    -3,    0],
        [-2,  1,  1,  0, 0,     -7,       0,     0,    0],
        [ 0, -1,  0,  2, 2,     -7,       0,     3,    0],
        [ 2,  0,  0,  2, 1,     -7,       0,     3,    0],
        [ 2,  0,  1,  0, 0,      6,       0,     0,    0],
        [-2,  0,  2,  2, 2,      6,       0,    -3,    0],
        [-2,  0,  1,  2, 1,      6,       0,    -3,    0],
        [ 2,  0, -2,  0, 1,     -6,       0,     3,    0],
        [ 2,  0,  0,  0, 1,     -6,       0,     3,    0],
        [ 0, -1,  1,  0, 0,      5,       0,     0,    0],
        [-2, -1,  0,  2, 1,     -5,       0,     3,    0],
        [-2,  0,  0,  0, 1,     -5,       0,     3,    0],
        [ 0,  0,  2,  2, 1,     -5,       0,     3,    0],
        [-2,  0,  2,  0, 1,      4,       0,     0,    0],
        [-2,  1,  0,  2, 1,      4,       0,     0,    0],
        [ 0,  0,  1, -2, 0,      4,       0,     0,    0],
        [-1,  0,  1,  0, 0,     -4,       0,     0,    0],
        [-2,  1,  0,  0, 0,     -4,       0,     0,    0],
        [ 1,  0,  0,  0, 0,     -4,       0,     0,    0],
        [ 0,  0,  1,  2, 0,      3,       0,     0,    0],
        [ 0,  0, -2,  2, 2,     -3,       0,     0,    0],
        [-1, -1,  1,  0, 0,     -3,       0,     0,    0],
        [ 0,  1,  1,  0, 0,     -3,       0,     0,    0],
        [ 0, -1,  1,  2, 2,     -3,       0,     0,    0],
        [ 2, -1, -1,  2, 2,     -3,       0,     0,    0],
        [ 0,  0,  3,  2, 2,      3,       0,     0,    0],
        [ 2, -1,  0,  2, 2,     -3,       0,     0,    0],
    ];
/* eslint-enable no-multi-spaces, array-bracket-spacing */

export { sunMeanAnomaly, sunMeanLongitude, meanObliquityOfEcliptic, moonArgumentOfLatitude, moonAscendingNodeLongitude,
    moonMeanAnomaly, moonMeanElongation, nutations };
